<template>
    <div v-if="className == 'sub-tab-wrap'" class="sub-tab-wrap">
        <template v-for="item in gnbs">
            <ul class="tab tab--inline" :key="item.title" v-if="item.title == sh">
                <li v-for="child in item.children" :key="child.title" class="tab__li" :class="{ active: tabActive == child.title }">
                    <a :href="child.path" class="tab__btn"
                        ><span>{{ child.title }}</span></a
                    >
                </li>
            </ul>
        </template>
    </div>
    <ul v-else-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :class="className + '__li'" :key="item.title">
                <a v-if="item.href" :href="item.href" :class="className + '__link'" target="_blank"
                    ><h2>{{ item.title }}</h2></a
                >
                <router-link v-else :to="item.path" :class="className + '__link'"
                    ><h2>{{ item.title }}</h2></router-link
                >
            </li>

            <li v-else :class="className + '__li'" :key="item.title">
                <div v-if="isMobile" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link v-else :to="item.path" :class="className + '__link gnb__link--toggle'"
                    ><h2>{{ item.title }}</h2></router-link
                >
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
        sh: String,
        tabActive: String,
    },
    data: function() {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "About us",
                    path: "/ko/aboutus/company-profile",
                    children: [
                        {
                            title: "회사 프로필",
                            path: "/ko/aboutus/company-profile",
                        },
                        {
                            title: "인증서",
                            path: "/ko/aboutus/certificate",
                        },
                        {
                            title: "조직도",
                            path: "/ko/aboutus/organization",
                        },
                        {
                            title: "위치",
                            path: "/ko/aboutus/location/paju",
                        },
                    ],
                },
                {
                    title: "Product",
                    path: "/ko/product/Analyzer",
                    children: [
                        {
                            title: "분석기 시스템",
                            path: "/ko/product/Analyzer",
                        },
                        {
                            title: "CEMS / AQMS",
                            path: "/ko/product/CEMS",
                        },
                        {
                            title: "액체 분석기 시스템",
                            path: "/ko/product/Liquid",
                        },
                        {
                            title: "샘플링 시스템",
                            path: "/ko/product/Sampling",
                        },
                        {
                            title: "부식 모니터링 시스템",
                            path: "/ko/product/Corrosion",
                        },
                    ],
                },
                {
                    title: "Project / Reference",
                    path: "/ko/project",
                    children: [
                        {
                            title: "Project",
                            path: "/ko/project",
                        },
                        {
                            title: "Reference",
                            path: "/ko/reference",
                        },
                    ],
                },
                {
                    title: "Alliance",
                    path: "/ko/alliance/#abb",
                    children: [
                        {
                            title: "ABB",
                            path: "/ko/alliance/#abb",
                        },
                        {
                            title: "TELEDYNE",
                            path: "/ko/alliance/#teledyne",
                        },
                        {
                            title: "PAC",
                            path: "/ko/alliance/#pac",
                        },
                        {
                            title: "METAL SAMPLES",
                            path: "/ko/alliance/#metal",
                        },
                        {
                            title: "EXTREL",
                            path: "/ko/alliance/#extrel",
                        },
                    ],
                },
            ],
        };
    },
    computed: {
        isDesktop: function() {
            return this.window.width >= 1200;
        },
        isMobile: function() {
            return this.window.width < 1200;
        },
    },
    created: function() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function() {},
    methods: {
        handleResize: function() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>

<style scoped></style>
